import styled from "styled-components";

const GlitchyTitle = styled.h1`
    font-size: 2.5em;
    text-transform: uppercase;
    font-family: var(--qanelas-main);
    font-weight: bold;

    color: white;
    -webkit-text-stroke: 1px var(--kpum-black);
    text-shadow: 0.1em 0.1em 0 var(--kpum-lightorange), -0.1em -0.1em 0 var(--kpum-teal);

    margin: 1em auto 0.5em auto;
    width: fit-content;
    text-align: center;
`;

export default GlitchyTitle;